var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _rect0, _rect1, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapRule22(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 100,
    viewBox: "0 0 158 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6702_28447)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 7.87891,
    width: 68.4583,
    height: 86.4286,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.25,
    y: 77.1914,
    width: 23.9604,
    height: 9.41302,
    rx: 4.70651,
    fill: "#5CB891"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7031,
    y: 15.582,
    width: 53.9109,
    height: 5.9901,
    rx: 2.99505,
    fill: "#B5B5B5",
    fillOpacity: 0.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5469,
    y: 38.6836,
    width: 44.4979,
    height: 2.56719,
    rx: 1.28359,
    fill: "#FE724C",
    fillOpacity: 0.31
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.7031,
    y: 23.2812,
    width: 53.9109,
    height: 8.55729,
    rx: 4.27865,
    fill: "#B5B5B5",
    fillOpacity: 0.3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8516,
    y: 37.8281,
    width: 5.9901,
    height: 5.13438,
    rx: 2.56719,
    fill: "#FE724C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5469,
    y: 46.3867,
    width: 44.4979,
    height: 3.42292,
    rx: 1.71146,
    fill: "#FE724C",
    fillOpacity: 0.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8516,
    y: 46.3867,
    width: 5.9901,
    height: 5.9901,
    rx: 2.99505,
    fill: "#FE724C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3125 49.3638L58.5823 49.094L59.2673 49.7788L61.0969 47.9492L61.3667 48.219L59.2671 50.3184L58.3125 49.3638Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5469,
    y: 55.7969,
    width: 44.4979,
    height: 3.42292,
    rx: 1.71146,
    fill: "#FE724C",
    fillOpacity: 0.06
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8516,
    y: 55.7969,
    width: 5.9901,
    height: 5.13438,
    rx: 2.56719,
    fill: "#FE724C",
    fillOpacity: 0.38
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 64.5469,
    y: 66.0664,
    width: 44.4979,
    height: 2.56719,
    rx: 1.28359,
    fill: "#FE724C",
    fillOpacity: 0.31
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8516,
    y: 65.2109,
    width: 5.9901,
    height: 5.13438,
    rx: 2.56719,
    fill: "#FE724C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3125 67.9654L58.5823 67.6956L59.2673 68.3804L61.0969 66.5508L61.3667 66.8206L59.2671 68.92L58.3125 67.9654Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3125 40.7388L58.5823 40.469L59.2673 41.1538L61.0969 39.3242L61.3667 39.594L59.2671 41.6934L58.3125 40.7388Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6702_28447",
    x: 0,
    y: -38.1211,
    width: 168.461,
    height: 186.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6702_28447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6702_28447",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapRule22);
export default __webpack_public_path__ + "static/media/cap_rule_2_2.dd9ba72043594654a156986a502b3712.svg";
export { ForwardRef as ReactComponent };